import { Modal, ModalBody, ModalHeader } from 'reactstrap';

/**
 * `ShowBenefitsModal` displays one or more key-benefit lists in a modal.
 *
 * It delegates rendering of the lists to `renderKeyBenefits` from
 * `ProductMethods` and shows the provided `title` in the modal header.
 */
import { KeyBenefitList } from './CommonTypes';
import { renderKeyBenefits } from './ProductMethods';

export type ShowBenefitsModalProps = {
  showModal: boolean;
  title: string;
  onCloseModal: () => void;
  showMoreItems?: KeyBenefitList[];
};

const ShowBenefitsModal = ({
  showModal,
  onCloseModal,
  title,
  showMoreItems
}: ShowBenefitsModalProps): JSX.Element => {
  const renderShowMoreItems = () => {
    return renderKeyBenefits(showMoreItems);
  };

  return (
    <Modal isOpen={showModal}>
      <ModalHeader
        toggle={onCloseModal}
        className='modal-header-title cms-modal-header-title'>
        <span>{title}</span>
      </ModalHeader>
      <ModalBody className='show-more-container'>
        <div className='cms'>{renderShowMoreItems()}</div>
      </ModalBody>
    </Modal>
  );
};

export default ShowBenefitsModal;
